<template>
	<section
		class="py-20 xl:pt-[120px] xl:pb-[60px] will-change relative z-[1]"
		:data-scroll-section="inner == 'false'"
	>
		<div class="px-content mb-12">
			<h2 class="text-heading mb-8" v-show="blockData.title">
				{{ blockData.title }}
			</h2>
		</div>

		<!-- filter -->
		<div
			class="filter-wrap px-content mb-10 grid xl:grid-cols-3 gap-3 xl:gap-x-6 xl:gap-y-10 relative z-20"
		>
			<div
				class="p-1 group cursor-pointer time-picker-filter flex items-center border border-navy-blue-02 rounded-sm relative"
			>
				<div
					class="flex flex-col gap-1 flex-grow bg-gray-300 text-gray-700 font-semibold w-full"
				>
					<span class="ml-8 text-[12px] text-mid-grey text-left" @click="qwe">{{
						__("Date", "ccave")
					}}</span>
					<div class="flex items-center w-full">
						<svg
							class="flex-shrink-0 mr-2"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M4.49996 4.35039C4.41712 4.35039 4.34996 4.41755 4.34996 4.50039V19.5004C4.34996 19.5832 4.41712 19.6504 4.49996 19.6504H19.5C19.5828 19.6504 19.65 19.5832 19.65 19.5004V4.50039C19.65 4.41755 19.5828 4.35039 19.5 4.35039H4.49996ZM3.14996 4.50039C3.14996 3.75481 3.75438 3.15039 4.49996 3.15039H19.5C20.2455 3.15039 20.85 3.75481 20.85 4.50039V19.5004C20.85 20.246 20.2455 20.8504 19.5 20.8504H4.49996C3.75438 20.8504 3.14996 20.246 3.14996 19.5004V4.50039Z"
								fill="#405664"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M16.5 1.65039C16.8313 1.65039 17.1 1.91902 17.1 2.25039V5.25039C17.1 5.58176 16.8313 5.85039 16.5 5.85039C16.1686 5.85039 15.9 5.58176 15.9 5.25039V2.25039C15.9 1.91902 16.1686 1.65039 16.5 1.65039Z"
								fill="#405664"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M7.49996 1.65039C7.83133 1.65039 8.09996 1.91902 8.09996 2.25039V5.25039C8.09996 5.58176 7.83133 5.85039 7.49996 5.85039C7.16859 5.85039 6.89996 5.58176 6.89996 5.25039V2.25039C6.89996 1.91902 7.16859 1.65039 7.49996 1.65039Z"
								fill="#405664"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M3.14996 8.25039C3.14996 7.91902 3.41859 7.65039 3.74996 7.65039H20.25C20.5813 7.65039 20.85 7.91902 20.85 8.25039C20.85 8.58176 20.5813 8.85039 20.25 8.85039H3.74996C3.41859 8.85039 3.14996 8.58176 3.14996 8.25039Z"
								fill="#405664"
							/>
						</svg>
						<date-range-picker
							ref="picker"
							:locale-data="{ firstDay: 1, format: 'dd.mm.yyyy' }"
							:minDate="getMinDate()"
							:singleDatePicker="false"
							:timePicker="false"
							:timePicker24Hour="true"
							:showWeekNumbers="false"
							:showDropdowns="false"
							:autoApply="false"
							:date-range="dateRange"
							:opens="'right'"
							v-model="dateRange"
							@update="onDateRangeChange"
						>
							<template #input="" style="min-width: 350px">
								<div class="flex w-full justify-between items-center">
									<span
										v-if="
											dateRange.startDate === null && dateRange.endDate === null
										"
										>{{ __("This Month", "ccave") }}</span
									>
									<span v-else
										>{{ formatFilterSelection(dateRange.startDate) }} -
										{{ formatFilterSelection(dateRange.endDate) }}</span
									>

									<svg
										class="fill-current h-4 w-4 ml-auto"
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 20 20"
									>
										<path
											d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
										/>
									</svg>
								</div>
							</template>
						</date-range-picker>
						<button
							type="button"
							v-if="dateRange.startDate !== null && dateRange.endDate !== null"
							@click="
								dateRange.startDate = null;
								dateRange.endDate = null;
								getEvents();
							"
						>
							<svg
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
								class="cursor-pointer z-50"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M3.50001 2.93359L13.0657 12.4993L12.5 13.065L2.93433 3.49928L3.50001 2.93359Z"
									fill="#405664"
								/>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M13.0657 3.49928L3.50001 13.065L2.93433 12.4993L12.5 2.93359L13.0657 3.49928Z"
									fill="#405664"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
			<div class="p-1 flex border border-navy-blue-02 rounded-sm relative">
				<div class="flex w-full">
					<button
						class="flex flex-col gap-1 flex-grow bg-gray-300 text-gray-700 font-semibold w-full"
						@click="toggle('filter-location')"
					>
						<span class="ml-8 text-[12px] text-mid-grey text-left w-fit">{{
							__("Location", "ccave")
						}}</span>
						<div class="flex items-center w-full">
							<svg
								class="flex-shrink-0 mr-2"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M12 12.75C13.6569 12.75 15 11.4069 15 9.75C15 8.09315 13.6569 6.75 12 6.75C10.3431 6.75 9 8.09315 9 9.75C9 11.4069 10.3431 12.75 12 12.75Z"
									stroke="#405664"
									stroke-width="1.2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
								<path
									d="M19.5 9.75C19.5 16.5 12 21.75 12 21.75C12 21.75 4.5 16.5 4.5 9.75C4.5 7.76088 5.29018 5.85322 6.6967 4.4467C8.10322 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75V9.75Z"
									stroke="#405664"
									stroke-width="1.2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
							<div class="flex items-center justify-between w-full">
								<span id="location-title" class="text-sm text-left">{{
									__("All Locations", "ccave")
								}}</span>
								<svg
									class="fill-current h-4 w-4 ml-auto"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 20 20"
								>
									<path
										d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
									/>
								</svg>
							</div>
						</div>
					</button>
					<button
						v-if="activeLocation"
						type="button"
						class="block mt-auto mb-1 h-fit"
						@click="clearFilter('location')"
					>
						<svg
							width="16"
							height="16"
							viewBox="0 0 16 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M3.50001 2.93359L13.0657 12.4993L12.5 13.065L2.93433 3.49928L3.50001 2.93359Z"
								fill="#405664"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M13.0657 3.49928L3.50001 13.065L2.93433 12.4993L12.5 2.93359L13.0657 3.49928Z"
								fill="#405664"
							/>
						</svg>
					</button>
				</div>
				<ul
					id="filter-location"
					class="bg-white absolute hidden activity-select"
				>
					<li
						class=""
						v-for="(location, index) in locations"
						:key="index"
						@click="
							setFilter('location', location);
							toggle('filter-location');
						"
					>
						<span class="block cursor-pointer px-6 py-4">{{ location }}</span>
					</li>
				</ul>
			</div>
			<div class="p-1 flex border border-navy-blue-02 rounded-sm relative">
				<button
					class="flex flex-col gap-1 flex-grow bg-gray-300 text-gray-700 font-semibold w-full"
					@click="toggle('filter-category')"
				>
					<span class="ml-8 text-[12px] text-mid-grey text-left">{{
						__("Category", "ccave")
					}}</span>
					<div class="flex items-center w-full">
						<svg
							class="flex-shrink-0 mr-2"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M3.75 12H20.25"
								stroke="#405664"
								stroke-width="1.2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M3.75 6H20.25"
								stroke="#405664"
								stroke-width="1.2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M3.75 18H20.25"
								stroke="#405664"
								stroke-width="1.2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
						<span id="category-title" class="text-sm">{{
							__("All Categories", "ccave")
						}}</span>
						<svg
							class="fill-current h-4 w-4 ml-auto"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20"
						>
							<path
								d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
							/>
						</svg>
					</div>
				</button>
				<button
					v-if="activeCategory"
					type="button"
					class="block mt-auto mb-1 h-fit"
					@click="clearFilter('category')"
				>
					<svg
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M3.50001 2.93359L13.0657 12.4993L12.5 13.065L2.93433 3.49928L3.50001 2.93359Z"
							fill="#405664"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M13.0657 3.49928L3.50001 13.065L2.93433 12.4993L12.5 2.93359L13.0657 3.49928Z"
							fill="#405664"
						/>
					</svg>
				</button>
				<ul
					id="filter-category"
					class="bg-white absolute hidden activity-select"
				>
					<li
						class=""
						v-for="(cat, index) in categories"
						:key="index"
						@click="
							setFilter('category', cat);
							toggle('filter-category');
						"
					>
						<span class="block cursor-pointer px-6 py-4">{{ cat.name }}</span>
					</li>
				</ul>
			</div>
		</div>
		<!-- ./filter -->
		<div v-if="isMobile" class="event-slider overflow-hidden">
			<div class="events-slider px-content" ref="sliderCalendar">
				<div class="swiper-wrapper">
					<a
						class="swiper-slide min-w-0 relative event-card flex flex-col transition-all"
						v-for="(event, index) in filteredEvents"
						:key="'mobile-' + index"
						:href="`${event.link}?event_date=${formatEventDate(event)}`"
					>
						<div>
							<img
								class="rounded-t object-cover w-full"
								v-if="event.data.fields.image"
								:src="event.data.fields.image.sizes.eventslide"
								:alt="event.data.fields.image.alt"
							/>
							<img
								class="rounded-t object-cover w-full"
								v-else
								:src="endpoints.template_url + '/assets/img/event-fallback.png'"
								alt="event-fallback-image"
							/>
						</div>
						<span
							class="date bg-white flex flex-col items-center justify-center rounded-sm px-[15px] py-[10px] absolute top-2 left-2"
						>
							<span
								class="text-4xl leading-tight font-canela tracking-[2px]"
								v-show="event.data.fields.start"
								>{{ formatDateDay(event.data.fields.start) }}</span
							>
							<span
								class="uppercase tracking-little"
								v-show="event.data.fields.start"
								>{{ formatDateMonth(event.data.fields.start) }}</span
							>
						</span>
						<div
							class="note flex flex-col flex-shrink bg-navy-blue-01 rounded-b text-white py-5 px-6 h-full transition-all"
						>
							<div
								class="text-lg leading-tight font-medium mb-6"
								v-if="event.title"
								v-html="event.title.rendered"
							></div>
							<div
								class="text-lg leading-tight font-medium mb-6"
								v-else
								v-html="event.post_title"
							></div>
							<div class="time-wrap flex items-center">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M12 22C16.9706 22 21 17.9706 21 13C21 8.02944 16.9706 4 12 4C7.02944 4 3 8.02944 3 13C3 17.9706 7.02944 22 12 22Z"
										stroke="#B7E4F8"
										stroke-width="1.2"
										stroke-linecap="square"
									/>
									<path
										d="M12 8V13L15 16"
										stroke="#B7E4F8"
										stroke-width="1.2"
										stroke-linecap="square"
									/>
									<path
										d="M2 5L5 2M19 2L22 5L19 2Z"
										stroke="#B7E4F8"
										stroke-width="1.2"
										stroke-linecap="square"
									/>
								</svg>
								<span
									class="ml-2 text-xs tracking-little font-bold"
									v-show="event.data.fields.start"
									>{{ formatTime(event.data.fields.start) }}</span
								>
							</div>
						</div>
					</a>
				</div>
			</div>
		</div>

		<!-- DESKTOP GRID (>= 1280px) -->
		<div v-else class="px-content">
			<div
				class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6"
			>
				<a
					class="relative event-card flex flex-col transition-all"
					v-for="(event, index) in filteredEvents"
					:key="'desktop-' + index"
					:href="`${event.link}?event_date=${formatEventDate(event)}`"
				>
					<div>
						<img
							class="rounded-t object-cover w-full"
							v-if="event.data.fields.image"
							:src="event.data.fields.image.sizes.eventslide"
							:alt="event.data.fields.image.alt"
						/>
						<img
							class="rounded-t object-cover w-full"
							v-else
							:src="endpoints.template_url + '/assets/img/event-fallback.png'"
							alt="event-fallback-image"
						/>
					</div>
					<span
						class="date bg-white flex flex-col items-center justify-center rounded-sm px-[15px] py-[10px] absolute top-2 left-2"
					>
						<span
							class="text-4xl leading-tight font-canela tracking-[2px]"
							v-show="event.data.fields.start"
							>{{ formatDateDay(event.data.fields.start) }}</span
						>
						<span
							class="uppercase tracking-little"
							v-show="event.data.fields.start"
							>{{ formatDateMonth(event.data.fields.start) }}</span
						>
					</span>
					<div
						class="note flex flex-col flex-shrink bg-navy-blue-01 rounded-b text-white py-5 px-6 h-full transition-all"
					>
						<div
							class="text-lg leading-tight font-medium mb-6"
							v-if="event.title"
							v-html="event.title.rendered"
						></div>
						<div
							class="text-lg leading-tight font-medium mb-6"
							v-else
							v-html="event.post_title"
						></div>
						<div class="time-wrap flex items-center">
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M12 22C16.9706 22 21 17.9706 21 13C21 8.02944 16.9706 4 12 4C7.02944 4 3 8.02944 3 13C3 17.9706 7.02944 22 12 22Z"
									stroke="#B7E4F8"
									stroke-width="1.2"
									stroke-linecap="square"
								/>
								<path
									d="M12 8V13L15 16"
									stroke="#B7E4F8"
									stroke-width="1.2"
									stroke-linecap="square"
								/>
								<path
									d="M2 5L5 2M19 2L22 5L19 2Z"
									stroke="#B7E4F8"
									stroke-width="1.2"
									stroke-linecap="square"
								/>
							</svg>
							<span
								class="ml-2 text-xs tracking-little font-bold"
								v-show="event.data.fields.start"
								>{{ formatTime(event.data.fields.start) }}</span
							>
						</div>
					</div>
				</a>
			</div>
		</div>

		<div
			v-if="!loading && filteredEvents.length === 0"
			class="px-content justify-center"
		>
			{{
				__(
					"Unfortunately there are no events for the selected criteria. Please amend filters.",
					"ccave"
				)
			}}
		</div>
	</section>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { format, parseISO, startOfMonth, endOfMonth, add, sub } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";
import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

export default {
	name: "Calendar",
	components: { DateRangePicker },
	data() {
		const today = new Date();

		const utcDate = today;

		return {
			isMobile: false,
			events: false,
			categories: false,
			locations: false,
			loading: false,
			activeCategory: false,
			activeLocation: false,
			toggleDate: false,
			date: false,
			isUserFiltered: false,
			currentDateFilter: "thisMonth",
			sliderCalendar: null,
			dateRange: {
				startDate: today,
				endDate: endOfMonth(add(utcDate, { months: 1 })),
			},
		};
	},
	mounted() {
		this.isMobile = window.innerWidth < 1280;
		this.getEvents();
	},
	computed: {
		filteredEvents() {
			if (!this.events) return [];

			const today = new Date();

			const selectedStart = this.dateRange?.startDate
				? new Date(this.dateRange.startDate.setHours(0, 0, 0, 0))
				: new Date(
						today.getFullYear(),
						today.getMonth(),
						today.getDate(),
						0,
						0,
						0,
						0
				  );

			const selectedEnd = this.dateRange?.endDate
				? new Date(this.dateRange.endDate.setHours(23, 59, 59, 999))
				: new Date(
						today.getFullYear(),
						today.getMonth(),
						today.getDate(),
						23,
						59,
						59,
						999
				  );

			let filtered = this.events.filter((event) => {
				const startDateStr = event?.data?.fields?.start;
				if (!startDateStr) return false;

				// Parse event date as local date
				const eventDate = new Date(startDateStr.replace(" ", "T"));

				return eventDate >= selectedStart && eventDate <= selectedEnd;
			});

			if (this.activeCategory) {
				filtered = filtered.filter((event) =>
					event.event_category?.some((catId) => catId === this.activeCategory)
				);
			}

			if (this.activeLocation) {
				filtered = filtered.filter((event) =>
					event.data?.fields?.location?.markers?.some(
						(m) => m.location_name?.name === this.activeLocation
					)
				);
			}
			return filtered;
		},
	},

	methods: {
		initSlider() {
			this.$nextTick(() => {
				if (!this.$refs.sliderCalendar) return;
				if (this.sliderCalendar) {
					this.sliderCalendar.destroy(true, true);
					this.sliderCalendar = null;
				}
				this.sliderCalendar = new Swiper(this.$refs.sliderCalendar, {
					slidesPerView: 1.2,
					spaceBetween: 12,
					breakpoints: {
						600: {
							slidesPerView: 2.2,
							spaceBetween: 16,
						},
					},
				});
			});
		},
		formatEventDate(event) {
			if (!event?.data?.fields?.start) return "";

			const date = new Date(event.data.fields.start);

			return date.toISOString().split("T")[0]; // YYYY-MM-DD
		},
		qwe(e) {
			e.preventDefault();
			e.stopPropagation();
			this.$refs.picker.togglePicker();
		},
		async getEvents() {
			this.loading = true;
			try {
				await this.getEventsCategories();

				let start =
					this.dateRange.startDate == null
						? this.getFirstLastMonthDate()[0]
						: this.dateRange.startDate;
				let end =
					this.dateRange.endDate == null
						? this.getFirstLastMonthDate()[1]
						: add(this.dateRange.endDate, { days: 1 });

				end.setHours(23, 59, 59, 999);

				start = format(start, "yyyy-MM-dd");
				end = format(end, "yyyy-MM-dd");

				const url_params = {
					start_date: start,
					end_date: end,
				};

				const searchParams = new URLSearchParams(url_params);
				const res = await this.$http.post(
					this.endpoints.rest_base_endpoint + "lustica/v1/filter_events",
					searchParams,
					{
						headers: {
							Accept: "application/json",
							"Content-Type":
								"application/x-www-form-urlencoded; charset=UTF-8",
						},
					}
				);

				this.events =
					res.data && res.data.data && res.data.data.posts
						? res.data.data.posts
						: [];
				this.filterLocations();

				this.events = res.data?.data?.posts ?? [];
				this.filterLocations();

				if (this.isMobile) {
					this.initSlider();
				}
			} catch (err) {
				console.error("Error fetching events:", err);
				this.events = [];
			} finally {
				this.loading = false;
			}
		},
		getEventsCategories() {
			return this.$http
				.get(this.endpoints.rest_base_endpoint + "wp/v2/event_category")
				.then((res) => {
					this.categories = res.data;
				})
				.catch((err) => {
					console.error("Error fetching event categories:", err);
				});
		},
		setFilter(filterName, category) {
			if (filterName === "category") {
				this.activeCategory = category.id;
				document.getElementById("category-title").innerHTML = category.name;
			} else if (filterName === "location") {
				this.activeLocation = category;
				document.getElementById("location-title").innerHTML = category;
			}
		},
		clearFilter(filterName) {
			if (filterName === "category") {
				this.activeCategory = false;
				document.getElementById("category-title").innerHTML = this.__(
					"All Categories",
					"ccave"
				);
			} else if (filterName === "location") {
				this.activeLocation = false;
				document.getElementById("location-title").innerHTML = this.__(
					"All Locations",
					"ccave"
				);
			}
		},
		goToLocation(event) {
			window.location.href = event.link;
		},
		filterLocations() {
			if (!this.events) {
				this.locations = [];
				return;
			}
			let results = [];
			this.events.forEach((event) => {
				if (
					event.data &&
					event.data.fields &&
					event.data.fields.location &&
					event.data.fields.location.markers &&
					event.data.fields.location.markers.length > 0 &&
					event.data.fields.location.markers[0].location_name &&
					event.data.fields.location.markers[0].location_name.name
				) {
					results.push(
						event.data.fields.location.markers[0].location_name.name
					);
				}
			});

			this.locations = results
				.map((result) => result)
				.filter((value, index, self) => self.indexOf(value) === index);
		},
		getMinDate() {
			let today = new Date();
			const timeZone = "Europe/Montenegro";
			const utcDate = zonedTimeToUtc(today, timeZone);
			today = sub(utcDate, { days: 1 });
			return today;
		},
		formatDateDay(date) {
			let formated = format(parseISO(date), "dd");
			return formated;
		},
		formatDateMonth(date) {
			let formated = format(parseISO(date), "MMM");
			return formated;
		},
		formatTime(date) {
			let formated = format(parseISO(date), "HH:mm");
			return formated;
		},
		formatFilterSelection(date) {
			return format(date, "dd.MM.yyyy");
		},
		getFirstLastMonthDate() {
			let today = new Date();
			const timeZone = "Europe/Montenegro";
			const utcDate = zonedTimeToUtc(today, timeZone);
			let firstLastDates = [utcDate, endOfMonth(utcDate)];
			return firstLastDates;
		},

		toggle(id) {
			let el = document.getElementById(id);
			if (el.classList.contains("hidden")) {
				el.classList.remove("hidden");
				el.classList.add("visible");
			} else {
				el.classList.remove("visible");
				el.classList.add("hidden");
			}
		},
		onDateRangeChange() {
			const today = new Date();
			const isThisMonthSelected =
				this.dateRange.startDate.getTime() === startOfMonth(today).getTime() &&
				this.dateRange.endDate.getTime() ===
					endOfMonth(add(today, { months: 1 })).getTime();

			if (isThisMonthSelected) {
				// Adjust startDate to today
				this.dateRange.startDate = today;
			}

			this.isUserFiltered = true;
			this.getEvents();
		},
	},
};
</script>
<style>
.swiper-container {
	width: 100%;
}
.swiper-wrapper {
	display: flex;
}
.swiper-slide {
	flex-shrink: 0;
	width: auto;
}
</style>
